import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Shown after logging in with a password someone else set (new account or reset by an admin):
// the person must choose their own before using the app.
function ChangePassword({ token, user, onDone, onLogout }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [again, setAgain] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setError('');
    if (next.length < 8) return setError('Use at least 8 characters.');
    if (next !== again) return setError("The two new passwords don't match.");
    setSaving(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ current_password: current, new_password: next })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || 'Could not change password');
      onDone(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const field = (label, value, set, testid, autoComplete) => (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <input type={show ? 'text' : 'password'} className="form-input" value={value} onChange={e => set(e.target.value)}
        data-testid={testid} autoComplete={autoComplete} required />
    </div>
  );

  return (
    <div className="login-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)', padding: '1rem' }}>
      <div style={{ background: 'white', padding: '2rem', borderRadius: 12, width: '100%', maxWidth: 420 }} data-testid="change-password-page">
        <h2 style={{ fontSize: '1.4rem', fontWeight: 700, marginBottom: '0.4rem' }}>Choose your own password</h2>
        <p style={{ color: '#64748B', fontSize: '0.9rem', marginBottom: '1.25rem' }}>
          Hi {user?.name?.split(' ')[0] || 'there'} — you're using a password someone else set. Please choose a new one
          that only you know (at least 8 characters).
        </p>
        {error && <div className="alert alert-error" data-testid="change-password-error">{error}</div>}
        <form onSubmit={save}>
          {field('Password you were given', current, setCurrent, 'current-password', 'current-password')}
          {field('New password', next, setNext, 'new-password', 'new-password')}
          {field('New password again', again, setAgain, 'new-password-again', 'new-password')}
          <button type="button" onClick={() => setShow(!show)} style={{ background: 'none', border: 0, color: '#3B82F6', cursor: 'pointer',
            display: 'inline-flex', gap: 6, alignItems: 'center', marginBottom: '1rem', padding: 0, fontSize: '0.875rem' }}>
            {show ? <EyeOff size={16} /> : <Eye size={16} />} {show ? 'Hide' : 'Show'} passwords
          </button>
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={saving} data-testid="change-password-save">
            {saving ? 'Saving...' : 'Save and continue'}
          </button>
        </form>
        <button type="button" onClick={onLogout} style={{ marginTop: '1rem', width: '100%', background: 'none', border: 0,
          color: '#64748B', cursor: 'pointer', fontSize: '0.875rem' }}>Log out</button>
      </div>
    </div>
  );
}

export default ChangePassword;
